import Immutable from 'immutable';
import moment from "moment";
import {getQueryUrlFromObject} from "../../utils/urlUtils";

const LOAD = 'pay/LOAD';
const LOAD_SUCCESS = 'pay/LOAD_SUCCESS';
const LOAD_REPORT_SUCCESS = 'pay/LOAD_REPORT_SUCCESS';
const LOAD_REPORT_FAIL = 'pay/LOAD_REPORT_FAIL';
const LOAD_REPORT_DETAILS_SUCCESS = 'pay/LOAD_REPORT_DETAILS_SUCCESS';
const LOAD_REPORT_DETAILS_FAIL = 'pay/LOAD_REPORT_DETAILS_FAIL';
const LOAD_BILLING_PRACTICES_SUCCESS = 'pay/LOAD_BILLING_PRACTICES_SUCCESS';
const LOAD_BILLING_PRACTICES_FAIL = 'pay/LOAD_BILLING_PRACTICES_FAIL';
const SAVE_TODAY_PRODUCTION = 'pay/SAVE_TODAY_PRODUCTION';
const CHANGE_INTERVAL_REQUEST_COUNT = 'pay/CHANGE_INTERVAL_REQUEST_COUNT';
const LOAD_FAIL = 'pay/LOAD_FAIL';
const SAVE_PARAMS = 'pay/SAVE_PARAMS';
const SAVE_LOCK_CALENDAR_DOCTOR_PAY = 'pay/SAVE_LOCK_CALENDAR_DOCTOR_PAY';
const SAVE_LOCK_CALENDAR_DOCTOR_FAIL = 'pay/SAVE_LOCK_CALENDAR_DOCTOR_FAIL';
const LOAD_CALENDAR_LOCK_SUCCESS = 'pay/LOAD_CALENDAR_LOCK_SUCCESS';
const LOAD_SEND_DR_PAY_REPORT = 'pay/LOAD_SEND_DR_PAY_REPORT'


const initialState = Immutable.fromJS({
  isLoad: false,
  loadErr: null,
  loading: false,
  billingData: null,
  reportData: null,
  billingParams: '',
  intervalReqCount: 0,
  todayProduction: null
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LOAD:
      return state
        .set('isLoad', true)
        .set('loadErr', null);

    case LOAD_SEND_DR_PAY_REPORT:
      return state
          .set('isLoad', true)
          .set('loadErr', null);

    case LOAD_SUCCESS:
      return state
        .set('isLoad', false)
        .set('loadErr', null)
        .set('billingData', action.res)
        .set('reportData', null)
        .set('intervalReqCount', 0)
        .set('reportDetailsData', null);

    case LOAD_FAIL:
      return state
        .set('isLoad', false)
        .set('loadErr', action.error)
        .set('billingData', null)
        .set('reportData', {})
        .set('reportDetailsData', {});

    case LOAD_REPORT_SUCCESS:
      return state
        .set('loadErr', null)
        .set('reportData', action.res)
        .set('reportDetailsData', null);

    case LOAD_REPORT_FAIL:
      return state
        .set('isLoad', false)
        .set('loadErr', action.error)
        .set('reportData', null);

    case LOAD_REPORT_DETAILS_SUCCESS:
      return state
        .set('loadErr', null)
        .set('reportDetailsData', action.res);

    case LOAD_REPORT_DETAILS_FAIL:
      return state
        .set('isLoad', false)
        .set('loadErr', action.error)
        .set('reportDetailsData', null);

    case SAVE_PARAMS:
      return state
        .set('billingParams', action.params);

    case CHANGE_INTERVAL_REQUEST_COUNT:
      return state
        .set('intervalReqCount', action.res);

    case SAVE_TODAY_PRODUCTION:
      return state
        .set('todayProduction', action.todayProduction);

    default:
      return state;
  }
};

export const getBillingData = (params = '') => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  let user = getState().get('auth').get('user');
  if(!user.UdaDrList.abbr || !user.UdaDrList.userId) {
    dispatch({ type: LOAD_FAIL, error: "Please add Dentist's details" });
  }
  if(params) {
    params = '/'+JSON.stringify(params);
  }
  try {
    let res = await api.get(`udr/api/pay/calendar/${user.UdaDrList.abbr}/${user.UdaDrList.userId}${params}`);
    dispatch({ type: LOAD_SUCCESS, res: res });
    if(params) {
      dispatch({ type: SAVE_PARAMS, params: params })
    }

    return res;
  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
  }
};
export const getCalendarLock= (params = '') => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  if(params) {
    params = '/'+JSON.stringify(params);
  }
  try {
    let res = await api.get(`udr/pay/getCalendarPayLock${params}`);
    dispatch({ type: LOAD_CALENDAR_LOCK_SUCCESS, res: res });
    if(params) {
    //  dispatch({ type: SAVE_PARAMS, params: params })
    }

    return res;
  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
  }
};

export const sendReport = (reportObj) => async (dispatch, getState, api) => {
  reportObj.params = getState().get('pay').get('billingParams');
  try {
    let res = await api.post('udr/pay/sendReport', {data:reportObj});
    dispatch({ type: LOAD_BILLING_PRACTICES_SUCCESS, res: res });
    return res;
  } catch (err) {
    dispatch({ type: LOAD_BILLING_PRACTICES_FAIL, error: err.message });
  }
};

export const sendHygienistBillableCareReport = (abbr, startDate) => async (dispatch, getState, api) => {
  try {
    const billingParams = getState().get('pay').get('billingParams');
    let res = await api.post('udr/pay/sendHygienistBillableCareReport', {
      data: {
        abbr,
        startDate,
        billingPractices: billingParams
      }
    });
    dispatch({ type: LOAD_BILLING_PRACTICES_SUCCESS, res: res });
    return res;
  } catch (err) {
    dispatch({ type: LOAD_BILLING_PRACTICES_FAIL, error: err.message });
    throw err;
  }
};

export const saveCalendarLock = (reportObj) => async (dispatch, getState, api) => {
  try {
    let res = await api.post('udr/pay/saveCalendarPayLock', {data:reportObj});
    dispatch({ type: SAVE_LOCK_CALENDAR_DOCTOR_PAY, res: res });
    return res;
  } catch (err) {
    dispatch({ type: SAVE_LOCK_CALENDAR_DOCTOR_FAIL, error: err.message });


  }
}

export const sendOrthoDrPayReport = (params) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  Object.assign(params, {timeStamp: moment().format('DD-MMMM-YYYY-hh:mmA')});
  try {
    if(params) {
      params = JSON.stringify(params);
    }
    let res = await api.get(`drPay/ndp/sendReport/${params}`);
    dispatch({ type: LOAD_SEND_DR_PAY_REPORT, res: res });
    return res;
  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });

  }
};



export const sendDrPayReport = (params, queryParams) => async (dispatch, getState, api) => {
  Object.assign(params, {timeStamp: moment().format('DD-MMMM-YYYY-hh:mmA')});
  try {
    let res = await api.post(`drPay/sendReport?${getQueryUrlFromObject(queryParams)}`, {data: params});
    dispatch({ type: LOAD_SEND_DR_PAY_REPORT, res: res });
    return res;
  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });

  }
};
// Warning-only: asks the API whether notes exist that the saved report this send reads does not include
export const checkOmittedNotes = (params, queryParams) => async (dispatch, getState, api) => {
  const query = getQueryUrlFromObject(queryParams || {});
  return api.get(`payReports/checkOmittedNotes/${JSON.stringify(params)}${query ? `?${query}` : ''}`);
};
export const getEarningsReportSettings =() => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    let res = await api.get(`reports/earningsReportSettings`);
    dispatch({ type: LOAD_SEND_DR_PAY_REPORT, res: res });
    return res;
  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });

  }
};


